import React from 'react';
import { useDropzone } from 'react-dropzone';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ReactComponent as ImageIcon } from '../../../resources/svg/image.svg';

const DropzoneContainer = styled(Grid)(({ theme, status }) => ({
	width: '100%',
	height: '100%',
	border: `2px dashed ${theme.palette.separator.primary}`,
	borderRadius: '15px',
	padding: theme.spacing(4),
	textAlign: 'center',
	cursor: 'pointer',
	backgroundColor: theme.palette[status]?.light || 'transparent',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	transition: 'background-color 0.3s',
	'&:hover': {
		backgroundColor: theme.palette.action.hover
	}
}));

const DropzoneMessage = styled(Typography)(({ theme }) => ({
	fontSize: '0.85rem',
	color: theme.palette.text.tertiary
}));

const DropzoneIcon = styled(ImageIcon)(({ theme }) => ({
	width: 50,
	height: 50,
	stroke: theme.palette.text.tertiary,
	marginBottom: theme.spacing(2),
	opacity: 0.7
}));

const defaultHelperText = 'Drag and drop your images here to upload them to your gallery';

const Dropzone = ({ onDrop, helpText = defaultHelperText }) => {
	const accept = {
		'image/jpeg': ['.jpeg', '.jpg'],
		'image/png': ['.png']
	};

	const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
		onDrop,
		accept
	});

	let status = '';
	if (isDragAccept) {
		status = 'info';
	} else if (isDragReject) {
		status = 'error';
	}

	return (
		<DropzoneContainer {...getRootProps()} status={status}>
			<input {...getInputProps()} />
			<DropzoneIcon />
			{/* <DropzoneTitle>Upload Your Images</DropzoneTitle> */}
			<DropzoneMessage>{helpText}</DropzoneMessage>
		</DropzoneContainer>
	);
};

export default Dropzone;
